/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button} from '@mui/material';

export const Root = styled(Box)(({theme}) => ({
  display: 'flex',
  borderRadius: theme.spacing(2),
  overflow: 'hidden',
  width: 'max-content',
}));

interface PeriodButtonProps {
  isSelected?: boolean;
}

export const PeriodButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'isSelected',
})<PeriodButtonProps>(({theme, isSelected}) => ({
  height: '56px',
  background: isSelected ? theme.palette.figma_gray_dark_3?.main : '#202020',
  borderRadius: 0,
  padding: theme.spacing(0, 4),

  color: theme.palette.figma_gray_light_1?.main,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
}));
